import { Box, FormControlLabel, Grid, Switch } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { DashboardConfiguration, IVehicleDetail } from '../../../generated/ApiClient';
import { ModelImage } from '../../deals/ModelImage';
import { formatToEuro } from '../../deals/new/finances/FinancesCalculationList';
import { getValueWithVatCoefficientApplied } from './OverlayDissolveValues.utils';

interface Props {
  vehicle?: IVehicleDetail;
  isLeasing?: boolean;
  canViewDetail?: boolean;
  showVatSwitch: boolean;
  dashboardConfiguration?: DashboardConfiguration;
  pricesIncludingVAT: boolean;
  onShowPricesIncludingVatChanged: (newValue: boolean) => void;
}

export function OverlayVehicle({
  vehicle,
  isLeasing,
  canViewDetail,
  showVatSwitch,
  dashboardConfiguration,
  pricesIncludingVAT,
  onShowPricesIncludingVatChanged,
}: Props) {
  const { t } = useTranslation();
  const fractionDigits = 3;

  const vatCoefficient =
    pricesIncludingVAT && dashboardConfiguration?.rate ? dashboardConfiguration?.rate : 1;

  console.log(vehicle?.vehicleCondition);
  return (
    <>
      <Grid container width="100%" mt={2}>
        <Grid item xs={6}>
          <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'left' }}>
            <FormControlLabel
              disabled={!showVatSwitch}
              onChange={() => onShowPricesIncludingVatChanged(!pricesIncludingVAT)}
              control={<Switch checked={pricesIncludingVAT} />}
              label={t('dashboard.contractsOverlay.pricesIncludingVAT')}
            />
          </Box>
          <Grid container sx={{ justifyContent: 'start', alignItems: 'start' }}>
            <Grid item xs={6} className="value-column">
              <div>{t('dashboard.contractsOverlay.vehicle.object')}</div>
            </Grid>
            <Grid item xs={6} className="value-column">
              <div>{vehicle?.objectName ?? ''}</div>
            </Grid>
            <Grid item xs={6} className="value-column">
              <div>{t('dashboard.contractsOverlay.vehicle.fin')}</div>
            </Grid>
            <Grid item xs={6} className="value-column">
              <div>{vehicle?.fin ?? ''}</div>
            </Grid>
            <Grid item xs={6} className="value-column">
              <div>{t('dashboard.contractsOverlay.vehicle.state')}</div>
            </Grid>
            <Grid item xs={6} className="value-column">
              <div>
                {vehicle?.vehicleCondition !== null
                  ? // @ts-ignore
                    t(`dashboard.contractsOverlay.vehicle.conditions.${vehicle?.vehicleCondition}`)
                  : ''}
              </div>
            </Grid>

            <Grid item xs={6} className="value-column">
              <div>{t('dashboard.contractsOverlay.vehicle.licencePlate')}</div>
            </Grid>
            <Grid item xs={6} className="value-column">
              <div>{vehicle?.numberPlate ?? '-'}</div>
            </Grid>

            {canViewDetail && (
              <>
                <Grid item xs={6} className="value-column">
                  <div>{t('dashboard.contractsOverlay.vehicle.contractStartMileage')}</div>
                </Grid>
                <Grid item xs={6} className="value-column">
                  <div>{vehicle?.contractStartMileage ?? '0'} km</div>
                </Grid>

                {isLeasing ? (
                  <>
                    <Grid item xs={6} className="value-column">
                      <div>{t('dashboard.contractsOverlay.vehicle.excessUnderMileageRate')}</div>
                    </Grid>
                    <Grid item xs={6} className="value-column">
                      <div>
                        {formatToEuro(
                          getValueWithVatCoefficientApplied(
                            vehicle?.excessUnderMileageRate,
                            vatCoefficient
                          ),
                          false,
                          fractionDigits
                        )}
                      </div>
                    </Grid>
                  </>
                ) : null}
              </>
            )}
          </Grid>
        </Grid>
        <Grid item xs={6}>
          {vehicle?.modelId && <ModelImage modelId={vehicle?.modelId} />}
        </Grid>
      </Grid>

      <div className="line" />
    </>
  );
}
